import { useNavigate, useParams } from "react-router-dom";
import { routes } from "src/routes";

export default function FilterButton() {
  const nav = useNavigate();
  const { companyId } = useParams();
  return (
    <button
      type="button"
      onClick={() => {
        nav(routes.Filter.url(companyId));
      }}
      className="inline-flex items-center hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg"
    >
      <i
        className={`${
          location.pathname.startsWith(routes.Filter.url(companyId))
            ? "text-PrimaryGreen fa-solid"
            : "text-SkaneGreen fa-solid"
        } fa-sliders text-xl`}
      />
    </button>
  );
}
